import { createSlice } from "@reduxjs/toolkit";
import { InitialProductFormData } from "../../ConstantData/InitialData";
import { InitialProductDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const productionSlice = createSlice({
  name: "product",
  initialState: {
    productionList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialProductFormData,
    initialDuplicateData: InitialProductDuplicateFormData,
  },
  reducers: {
    getAllProduction: (state, action) => {
      state.productList = action.payload;
    },
    getProductionDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialProductFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = { ...InitialProductDuplicateFormData };
    },
    updateProduction: (state, action) => {},
    deleteProduction: () => {},
  },
});

export const productionSliceAction = productionSlice.actions;
export default productionSlice.reducer;
